import React from 'react';

export default function Logo({ light = false }) {
  return (
    <div className="flex items-center gap-3 group cursor-pointer">
      {/* SVG Logo Mark */}
      <div className="relative w-10 h-10">
        <svg 
          viewBox="0 0 40 40" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          <rect 
            width="40" 
            height="40" 
            className={`${light ? 'fill-white/10' : 'fill-slate-900/5'} transition-colors group-hover:fill-amber-600/10`} 
          />
          <path 
            d="M12 10H28V14H16V18H26V22H16V26H28V30H12V10Z" 
            className={`${light ? 'fill-white' : 'fill-slate-900'} transition-colors group-hover:fill-amber-600`}
          />
          <path 
            d="M8 8V32H32V8H8ZM34 6V34H6V6H34Z" 
            className={`${light ? 'fill-white/30' : 'fill-slate-900/20'} transition-colors group-hover:fill-amber-600/50`}
          />
        </svg>
      </div>

      <div className="flex flex-col">
        <span className={`font-serif font-bold text-xl leading-none tracking-tight
          ${light ? 'text-white' : 'text-slate-900'}`}>
          Eldenwyck
        </span>
        <span className={`text-[0.65rem] font-sans tracking-[0.2em] uppercase mt-0.5
          ${light ? 'text-slate-300' : 'text-slate-500'}`}>
          & Company
        </span>
      </div>
    </div>
  );
}